// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiV1ModelingCustomModulesByCustomModuleId, deleteApiV1ModelingModuleRunsByModuleRunIdShare, deleteApiV1ModelingPathsByPathRunIdShare, deleteApiV1ModelingPathTemplatesByPathTemplateId, deleteApiV1ModelingPathTemplatesByPathTemplateIdFavorite, getApiV1AuthUserinfo, getApiV1ClientsExternal, getApiV1ClientsExternalByPersonalNumber, getApiV1FilesByPublicTokenContent, getApiV1ModelingCustomModules, getApiV1ModelingCustomModulesByCustomModuleId, getApiV1ModelingFormsCountries, getApiV1ModelingFormsPalette, getApiV1ModelingModuleRuns, getApiV1ModelingModuleRunsByModuleRunId, getApiV1ModelingModuleRunsPublicByPublicShareToken, getApiV1ModelingModulesCatalog, getApiV1ModelingPaths, getApiV1ModelingPathsByPathRunId, getApiV1ModelingPathsByPathRunIdVersions, getApiV1ModelingPathsPublicByPublicShareToken, getApiV1ModelingPathTemplates, getApiV1ModelingPathTemplatesByPathTemplateId, getApiV1ModelingPathTemplatesContainingModuleByModuleKey, getApiV1ModelingSystemInputs, getApiV1PdfModuleSample, getApiV1PdfPathRender, getApiV1PdfSample, getApiV1Users, getApiV1UsersByUserId, type Options, postApiV1AuthBrokerSignIn, postApiV1AuthSignIn, postApiV1Files, postApiV1ModelingAiClientSummary, postApiV1ModelingCustomModules, postApiV1ModelingModuleRuns, postApiV1ModelingModuleRunsByModuleRunIdClientSummary, postApiV1ModelingModuleRunsByModuleRunIdClose, postApiV1ModelingModuleRunsByModuleRunIdInputs, postApiV1ModelingModuleRunsByModuleRunIdOutputs, postApiV1ModelingModuleRunsByModuleRunIdReopen, postApiV1ModelingModuleRunsByModuleRunIdShare, postApiV1ModelingModuleRunsByModuleRunIdShareEmail, postApiV1ModelingPaths, postApiV1ModelingPathsByPathRunIdClientSummary, postApiV1ModelingPathsByPathRunIdClose, postApiV1ModelingPathsByPathRunIdShare, postApiV1ModelingPathsByPathRunIdShareEmail, postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingMode, postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummary, postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponse, postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputs, postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputs, postApiV1ModelingPathTemplates, postApiV1ModelingPathTemplatesByPathTemplateIdFavorite, postApiV1PdfModuleByModuleKey, postApiV1PdfPathByPathRunId, putApiV1ModelingCustomModulesByCustomModuleId, putApiV1ModelingPathTemplatesByPathTemplateId } from '../sdk.gen';
import type { DeleteApiV1ModelingCustomModulesByCustomModuleIdData, DeleteApiV1ModelingCustomModulesByCustomModuleIdError, DeleteApiV1ModelingCustomModulesByCustomModuleIdResponse, DeleteApiV1ModelingModuleRunsByModuleRunIdShareData, DeleteApiV1ModelingModuleRunsByModuleRunIdShareError, DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponse, DeleteApiV1ModelingPathsByPathRunIdShareData, DeleteApiV1ModelingPathsByPathRunIdShareError, DeleteApiV1ModelingPathsByPathRunIdShareResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdData, DeleteApiV1ModelingPathTemplatesByPathTemplateIdError, DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData, DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponse, GetApiV1AuthUserinfoData, GetApiV1AuthUserinfoError, GetApiV1AuthUserinfoResponse, GetApiV1ClientsExternalByPersonalNumberData, GetApiV1ClientsExternalByPersonalNumberError, GetApiV1ClientsExternalByPersonalNumberResponse, GetApiV1ClientsExternalData, GetApiV1ClientsExternalError, GetApiV1ClientsExternalResponse, GetApiV1FilesByPublicTokenContentData, GetApiV1FilesByPublicTokenContentError, GetApiV1ModelingCustomModulesByCustomModuleIdData, GetApiV1ModelingCustomModulesByCustomModuleIdError, GetApiV1ModelingCustomModulesByCustomModuleIdResponse, GetApiV1ModelingCustomModulesData, GetApiV1ModelingCustomModulesError, GetApiV1ModelingCustomModulesResponse, GetApiV1ModelingFormsCountriesData, GetApiV1ModelingFormsCountriesError, GetApiV1ModelingFormsCountriesResponse, GetApiV1ModelingFormsPaletteData, GetApiV1ModelingFormsPaletteError, GetApiV1ModelingFormsPaletteResponse, GetApiV1ModelingModuleRunsByModuleRunIdData, GetApiV1ModelingModuleRunsByModuleRunIdError, GetApiV1ModelingModuleRunsByModuleRunIdResponse, GetApiV1ModelingModuleRunsData, GetApiV1ModelingModuleRunsError, GetApiV1ModelingModuleRunsPublicByPublicShareTokenData, GetApiV1ModelingModuleRunsPublicByPublicShareTokenError, GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponse, GetApiV1ModelingModuleRunsResponse, GetApiV1ModelingModulesCatalogData, GetApiV1ModelingModulesCatalogError, GetApiV1ModelingModulesCatalogResponse, GetApiV1ModelingPathsByPathRunIdData, GetApiV1ModelingPathsByPathRunIdError, GetApiV1ModelingPathsByPathRunIdResponse, GetApiV1ModelingPathsByPathRunIdVersionsData, GetApiV1ModelingPathsByPathRunIdVersionsError, GetApiV1ModelingPathsByPathRunIdVersionsResponse, GetApiV1ModelingPathsData, GetApiV1ModelingPathsError, GetApiV1ModelingPathsPublicByPublicShareTokenData, GetApiV1ModelingPathsPublicByPublicShareTokenError, GetApiV1ModelingPathsPublicByPublicShareTokenResponse, GetApiV1ModelingPathsResponse, GetApiV1ModelingPathTemplatesByPathTemplateIdData, GetApiV1ModelingPathTemplatesByPathTemplateIdError, GetApiV1ModelingPathTemplatesByPathTemplateIdResponse, GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyData, GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyError, GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponse, GetApiV1ModelingPathTemplatesData, GetApiV1ModelingPathTemplatesError, GetApiV1ModelingPathTemplatesResponse, GetApiV1ModelingSystemInputsData, GetApiV1ModelingSystemInputsError, GetApiV1ModelingSystemInputsResponse, GetApiV1PdfModuleSampleData, GetApiV1PdfModuleSampleError, GetApiV1PdfModuleSampleResponse, GetApiV1PdfPathRenderData, GetApiV1PdfPathRenderError, GetApiV1PdfPathRenderResponse, GetApiV1PdfSampleData, GetApiV1PdfSampleError, GetApiV1PdfSampleResponse, GetApiV1UsersByUserIdData, GetApiV1UsersByUserIdError, GetApiV1UsersByUserIdResponse, GetApiV1UsersData, GetApiV1UsersError, GetApiV1UsersResponse, PostApiV1AuthBrokerSignInData, PostApiV1AuthBrokerSignInError, PostApiV1AuthBrokerSignInResponse, PostApiV1AuthSignInData, PostApiV1AuthSignInError, PostApiV1AuthSignInResponse, PostApiV1FilesData, PostApiV1FilesError, PostApiV1FilesResponse, PostApiV1ModelingAiClientSummaryData, PostApiV1ModelingAiClientSummaryError, PostApiV1ModelingAiClientSummaryResponse, PostApiV1ModelingCustomModulesData, PostApiV1ModelingCustomModulesError, PostApiV1ModelingCustomModulesResponse, PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryData, PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryError, PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponse, PostApiV1ModelingModuleRunsByModuleRunIdCloseData, PostApiV1ModelingModuleRunsByModuleRunIdCloseError, PostApiV1ModelingModuleRunsByModuleRunIdCloseResponse, PostApiV1ModelingModuleRunsByModuleRunIdInputsData, PostApiV1ModelingModuleRunsByModuleRunIdInputsError, PostApiV1ModelingModuleRunsByModuleRunIdInputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdOutputsData, PostApiV1ModelingModuleRunsByModuleRunIdOutputsError, PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdReopenData, PostApiV1ModelingModuleRunsByModuleRunIdReopenError, PostApiV1ModelingModuleRunsByModuleRunIdReopenResponse, PostApiV1ModelingModuleRunsByModuleRunIdShareData, PostApiV1ModelingModuleRunsByModuleRunIdShareEmailData, PostApiV1ModelingModuleRunsByModuleRunIdShareEmailError, PostApiV1ModelingModuleRunsByModuleRunIdShareError, PostApiV1ModelingModuleRunsByModuleRunIdShareResponse, PostApiV1ModelingModuleRunsData, PostApiV1ModelingModuleRunsError, PostApiV1ModelingModuleRunsResponse, PostApiV1ModelingPathsByPathRunIdClientSummaryData, PostApiV1ModelingPathsByPathRunIdClientSummaryError, PostApiV1ModelingPathsByPathRunIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdCloseData, PostApiV1ModelingPathsByPathRunIdCloseError, PostApiV1ModelingPathsByPathRunIdCloseResponse, PostApiV1ModelingPathsByPathRunIdShareData, PostApiV1ModelingPathsByPathRunIdShareEmailData, PostApiV1ModelingPathsByPathRunIdShareEmailError, PostApiV1ModelingPathsByPathRunIdShareError, PostApiV1ModelingPathsByPathRunIdShareResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeData, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeError, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryData, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryError, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseData, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseError, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsData, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsError, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsData, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsError, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponse, PostApiV1ModelingPathsData, PostApiV1ModelingPathsError, PostApiV1ModelingPathsResponse, PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData, PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, PostApiV1ModelingPathTemplatesData, PostApiV1ModelingPathTemplatesError, PostApiV1ModelingPathTemplatesResponse, PostApiV1PdfModuleByModuleKeyData, PostApiV1PdfModuleByModuleKeyError, PostApiV1PdfModuleByModuleKeyResponse, PostApiV1PdfPathByPathRunIdData, PostApiV1PdfPathByPathRunIdError, PostApiV1PdfPathByPathRunIdResponse, PutApiV1ModelingCustomModulesByCustomModuleIdData, PutApiV1ModelingCustomModulesByCustomModuleIdError, PutApiV1ModelingCustomModulesByCustomModuleIdResponse, PutApiV1ModelingPathTemplatesByPathTemplateIdData, PutApiV1ModelingPathTemplatesByPathTemplateIdError, PutApiV1ModelingPathTemplatesByPathTemplateIdResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiV1UsersQueryKey = (options?: Options<GetApiV1UsersData>) => createQueryKey('getApiV1Users', options);

export const getApiV1UsersOptions = (options?: Options<GetApiV1UsersData>) => queryOptions<GetApiV1UsersResponse, GetApiV1UsersError, GetApiV1UsersResponse, ReturnType<typeof getApiV1UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UsersQueryKey(options)
});

export const getApiV1UsersByUserIdQueryKey = (options: Options<GetApiV1UsersByUserIdData>) => createQueryKey('getApiV1UsersByUserId', options);

export const getApiV1UsersByUserIdOptions = (options: Options<GetApiV1UsersByUserIdData>) => queryOptions<GetApiV1UsersByUserIdResponse, GetApiV1UsersByUserIdError, GetApiV1UsersByUserIdResponse, ReturnType<typeof getApiV1UsersByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1UsersByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1UsersByUserIdQueryKey(options)
});

export const getApiV1PdfSampleQueryKey = (options?: Options<GetApiV1PdfSampleData>) => createQueryKey('getApiV1PdfSample', options);

/**
 * Phase-0 walking skeleton — renders a trivial HTML document to PDF via
 * Gotenberg and streams it. `[AllowAnonymous]` + GET so it can be hit
 * straight from a browser to verify the pipeline; it will be replaced by the
 * per-run, token-gated generator once the print page exists.
 */
export const getApiV1PdfSampleOptions = (options?: Options<GetApiV1PdfSampleData>) => queryOptions<GetApiV1PdfSampleResponse, GetApiV1PdfSampleError, GetApiV1PdfSampleResponse, ReturnType<typeof getApiV1PdfSampleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PdfSample({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PdfSampleQueryKey(options)
});

export const getApiV1PdfModuleSampleQueryKey = (options?: Options<GetApiV1PdfModuleSampleData>) => createQueryKey('getApiV1PdfModuleSample', options);

/**
 * Phase-1 sample — renders the "Proč hypotéku" (HousingRentVsMortgage)
 * modelation to PDF by snapshotting the self-contained FE print page through
 * Gotenberg. `[AllowAnonymous]` + GET for easy verification; the real
 * per-run generator (resolving a persisted ModuleRun via a render token)
 * supersedes it.
 */
export const getApiV1PdfModuleSampleOptions = (options?: Options<GetApiV1PdfModuleSampleData>) => queryOptions<GetApiV1PdfModuleSampleResponse, GetApiV1PdfModuleSampleError, GetApiV1PdfModuleSampleResponse, ReturnType<typeof getApiV1PdfModuleSampleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PdfModuleSample({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PdfModuleSampleQueryKey(options)
});

/**
 * Generates a client-facing PDF of a single calculator module from the live
 * inputs the advisor has entered (the request body is the module's raw input
 * JSON) and streams it back. Requires authentication.
 */
export const postApiV1PdfModuleByModuleKeyMutation = (options?: Partial<Options<PostApiV1PdfModuleByModuleKeyData>>): UseMutationOptions<PostApiV1PdfModuleByModuleKeyResponse, PostApiV1PdfModuleByModuleKeyError, Options<PostApiV1PdfModuleByModuleKeyData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PdfModuleByModuleKeyResponse, PostApiV1PdfModuleByModuleKeyError, Options<PostApiV1PdfModuleByModuleKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PdfModuleByModuleKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generates a single combined client-facing PDF for a whole path run from the
 * advisor-selected steps (the request body is the list of step ids to include).
 * Module + custom-form steps are rendered through the Gotenberg pipeline and
 * uploaded-PDF steps are merged in at their position, in step order. Requires
 * authentication. Streamed back; not persisted.
 */
export const postApiV1PdfPathByPathRunIdMutation = (options?: Partial<Options<PostApiV1PdfPathByPathRunIdData>>): UseMutationOptions<PostApiV1PdfPathByPathRunIdResponse, PostApiV1PdfPathByPathRunIdError, Options<PostApiV1PdfPathByPathRunIdData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1PdfPathByPathRunIdResponse, PostApiV1PdfPathByPathRunIdError, Options<PostApiV1PdfPathByPathRunIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1PdfPathByPathRunId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1PdfPathRenderQueryKey = (options?: Options<GetApiV1PdfPathRenderData>) => createQueryKey('getApiV1PdfPathRender', options);

/**
 * Anonymous render-data endpoint consumed only by the FE print-path page that
 * Gotenberg's headless browser navigates to. Authorized by the short-lived
 * <b>render token</b> issued by Task&lt;IActionResult&gt; PdfController.GeneratePath(PathRunID pathRunId, IReadOnlyList&lt;PathRunStepID&gt; selectedStepIds, CancellationToken cancellationToken) (NOT a public share
 * link); returns the client-safe step data for the run scoped to that token.
 */
export const getApiV1PdfPathRenderOptions = (options?: Options<GetApiV1PdfPathRenderData>) => queryOptions<GetApiV1PdfPathRenderResponse, GetApiV1PdfPathRenderError, GetApiV1PdfPathRenderResponse, ReturnType<typeof getApiV1PdfPathRenderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1PdfPathRender({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1PdfPathRenderQueryKey(options)
});

export const getApiV1ModelingSystemInputsQueryKey = (options?: Options<GetApiV1ModelingSystemInputsData>) => createQueryKey('getApiV1ModelingSystemInputs', options);

export const getApiV1ModelingSystemInputsOptions = (options?: Options<GetApiV1ModelingSystemInputsData>) => queryOptions<GetApiV1ModelingSystemInputsResponse, GetApiV1ModelingSystemInputsError, GetApiV1ModelingSystemInputsResponse, ReturnType<typeof getApiV1ModelingSystemInputsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingSystemInputs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingSystemInputsQueryKey(options)
});

export const getApiV1ModelingPathTemplatesQueryKey = (options?: Options<GetApiV1ModelingPathTemplatesData>) => createQueryKey('getApiV1ModelingPathTemplates', options);

export const getApiV1ModelingPathTemplatesOptions = (options?: Options<GetApiV1ModelingPathTemplatesData>) => queryOptions<GetApiV1ModelingPathTemplatesResponse, GetApiV1ModelingPathTemplatesError, GetApiV1ModelingPathTemplatesResponse, ReturnType<typeof getApiV1ModelingPathTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathTemplatesQueryKey(options)
});

export const postApiV1ModelingPathTemplatesMutation = (options?: Partial<Options<PostApiV1ModelingPathTemplatesData>>): UseMutationOptions<PostApiV1ModelingPathTemplatesResponse, PostApiV1ModelingPathTemplatesError, Options<PostApiV1ModelingPathTemplatesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathTemplatesResponse, PostApiV1ModelingPathTemplatesError, Options<PostApiV1ModelingPathTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiV1ModelingPathTemplatesByPathTemplateIdMutation = (options?: Partial<Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdData>>): UseMutationOptions<DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdError, Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ModelingPathTemplatesByPathTemplateIdResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdError, Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1ModelingPathTemplatesByPathTemplateId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingPathTemplatesByPathTemplateIdQueryKey = (options: Options<GetApiV1ModelingPathTemplatesByPathTemplateIdData>) => createQueryKey('getApiV1ModelingPathTemplatesByPathTemplateId', options);

export const getApiV1ModelingPathTemplatesByPathTemplateIdOptions = (options: Options<GetApiV1ModelingPathTemplatesByPathTemplateIdData>) => queryOptions<GetApiV1ModelingPathTemplatesByPathTemplateIdResponse, GetApiV1ModelingPathTemplatesByPathTemplateIdError, GetApiV1ModelingPathTemplatesByPathTemplateIdResponse, ReturnType<typeof getApiV1ModelingPathTemplatesByPathTemplateIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathTemplatesByPathTemplateId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathTemplatesByPathTemplateIdQueryKey(options)
});

export const putApiV1ModelingPathTemplatesByPathTemplateIdMutation = (options?: Partial<Options<PutApiV1ModelingPathTemplatesByPathTemplateIdData>>): UseMutationOptions<PutApiV1ModelingPathTemplatesByPathTemplateIdResponse, PutApiV1ModelingPathTemplatesByPathTemplateIdError, Options<PutApiV1ModelingPathTemplatesByPathTemplateIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ModelingPathTemplatesByPathTemplateIdResponse, PutApiV1ModelingPathTemplatesByPathTemplateIdError, Options<PutApiV1ModelingPathTemplatesByPathTemplateIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1ModelingPathTemplatesByPathTemplateId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingPathTemplatesContainingModuleByModuleKeyQueryKey = (options: Options<GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyData>) => createQueryKey('getApiV1ModelingPathTemplatesContainingModuleByModuleKey', options);

/**
 * Lists every accessible, active template that contains moduleKey
 * as a ModelingModule step — one row per step occurrence. Used by the standalone
 * module page to offer "open this module inside a path" with carried-over inputs.
 */
export const getApiV1ModelingPathTemplatesContainingModuleByModuleKeyOptions = (options: Options<GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyData>) => queryOptions<GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponse, GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyError, GetApiV1ModelingPathTemplatesContainingModuleByModuleKeyResponse, ReturnType<typeof getApiV1ModelingPathTemplatesContainingModuleByModuleKeyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathTemplatesContainingModuleByModuleKey({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathTemplatesContainingModuleByModuleKeyQueryKey(options)
});

export const deleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteMutation = (options?: Partial<Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>>): UseMutationOptions<DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, Options<DeleteApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1ModelingPathTemplatesByPathTemplateIdFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingPathTemplatesByPathTemplateIdFavoriteMutation = (options?: Partial<Options<PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>>): UseMutationOptions<PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, Options<PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteResponse, PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteError, Options<PostApiV1ModelingPathTemplatesByPathTemplateIdFavoriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathTemplatesByPathTemplateIdFavorite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingPathsQueryKey = (options?: Options<GetApiV1ModelingPathsData>) => createQueryKey('getApiV1ModelingPaths', options);

export const getApiV1ModelingPathsOptions = (options?: Options<GetApiV1ModelingPathsData>) => queryOptions<GetApiV1ModelingPathsResponse, GetApiV1ModelingPathsError, GetApiV1ModelingPathsResponse, ReturnType<typeof getApiV1ModelingPathsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPaths({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathsQueryKey(options)
});

export const postApiV1ModelingPathsMutation = (options?: Partial<Options<PostApiV1ModelingPathsData>>): UseMutationOptions<PostApiV1ModelingPathsResponse, PostApiV1ModelingPathsError, Options<PostApiV1ModelingPathsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsResponse, PostApiV1ModelingPathsError, Options<PostApiV1ModelingPathsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPaths({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingPathsByPathRunIdQueryKey = (options: Options<GetApiV1ModelingPathsByPathRunIdData>) => createQueryKey('getApiV1ModelingPathsByPathRunId', options);

export const getApiV1ModelingPathsByPathRunIdOptions = (options: Options<GetApiV1ModelingPathsByPathRunIdData>) => queryOptions<GetApiV1ModelingPathsByPathRunIdResponse, GetApiV1ModelingPathsByPathRunIdError, GetApiV1ModelingPathsByPathRunIdResponse, ReturnType<typeof getApiV1ModelingPathsByPathRunIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathsByPathRunId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathsByPathRunIdQueryKey(options)
});

/**
 * Disables the public share link for this path run.
 */
export const deleteApiV1ModelingPathsByPathRunIdShareMutation = (options?: Partial<Options<DeleteApiV1ModelingPathsByPathRunIdShareData>>): UseMutationOptions<DeleteApiV1ModelingPathsByPathRunIdShareResponse, DeleteApiV1ModelingPathsByPathRunIdShareError, Options<DeleteApiV1ModelingPathsByPathRunIdShareData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ModelingPathsByPathRunIdShareResponse, DeleteApiV1ModelingPathsByPathRunIdShareError, Options<DeleteApiV1ModelingPathsByPathRunIdShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1ModelingPathsByPathRunIdShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Turns on (or returns the existing) public share link for this path run.
 * The run must be bound to a client. Returns the opaque token the FE uses to
 * build the public client-view URL.
 */
export const postApiV1ModelingPathsByPathRunIdShareMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdShareData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdShareResponse, PostApiV1ModelingPathsByPathRunIdShareError, Options<PostApiV1ModelingPathsByPathRunIdShareData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdShareResponse, PostApiV1ModelingPathsByPathRunIdShareError, Options<PostApiV1ModelingPathsByPathRunIdShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * E-mails the existing public share link of this path run to its bound client.
 * The run must already be shared and the client must have an e-mail on file.
 * The message is queued for asynchronous delivery (transactional outbox).
 */
export const postApiV1ModelingPathsByPathRunIdShareEmailMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdShareEmailData>>): UseMutationOptions<unknown, PostApiV1ModelingPathsByPathRunIdShareEmailError, Options<PostApiV1ModelingPathsByPathRunIdShareEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1ModelingPathsByPathRunIdShareEmailError, Options<PostApiV1ModelingPathsByPathRunIdShareEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdShareEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingPathsPublicByPublicShareTokenQueryKey = (options: Options<GetApiV1ModelingPathsPublicByPublicShareTokenData>) => createQueryKey('getApiV1ModelingPathsPublicByPublicShareToken', options);

/**
 * Public, anonymously-readable client view of a shared path run, resolved by
 * its opaque share token. No authentication required; returns 404 when the
 * token is unknown or the link has been revoked. Excludes internal steps and
 * client PII.
 */
export const getApiV1ModelingPathsPublicByPublicShareTokenOptions = (options: Options<GetApiV1ModelingPathsPublicByPublicShareTokenData>) => queryOptions<GetApiV1ModelingPathsPublicByPublicShareTokenResponse, GetApiV1ModelingPathsPublicByPublicShareTokenError, GetApiV1ModelingPathsPublicByPublicShareTokenResponse, ReturnType<typeof getApiV1ModelingPathsPublicByPublicShareTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathsPublicByPublicShareToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathsPublicByPublicShareTokenQueryKey(options)
});

export const getApiV1ModelingPathsByPathRunIdVersionsQueryKey = (options: Options<GetApiV1ModelingPathsByPathRunIdVersionsData>) => createQueryKey('getApiV1ModelingPathsByPathRunIdVersions', options);

/**
 * Lists every version inside the lineage of `pathRunId`, newest first.
 * Used by the FE "Verze této cesty" panel to browse and reopen older
 * versions of a client path.
 */
export const getApiV1ModelingPathsByPathRunIdVersionsOptions = (options: Options<GetApiV1ModelingPathsByPathRunIdVersionsData>) => queryOptions<GetApiV1ModelingPathsByPathRunIdVersionsResponse, GetApiV1ModelingPathsByPathRunIdVersionsError, GetApiV1ModelingPathsByPathRunIdVersionsResponse, ReturnType<typeof getApiV1ModelingPathsByPathRunIdVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingPathsByPathRunIdVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingPathsByPathRunIdVersionsQueryKey(options)
});

export const postApiV1ModelingPathsByPathRunIdCloseMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdCloseData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdCloseResponse, PostApiV1ModelingPathsByPathRunIdCloseError, Options<PostApiV1ModelingPathsByPathRunIdCloseData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdCloseResponse, PostApiV1ModelingPathsByPathRunIdCloseError, Options<PostApiV1ModelingPathsByPathRunIdCloseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdClose({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingModeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdBindingMode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sets (or clears) the overall client-facing summary ("shrnutí pro klienta")
 * for the whole path run. Send an empty/null body value to clear it.
 */
export const postApiV1ModelingPathsByPathRunIdClientSummaryMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdClientSummaryData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdClientSummaryError, Options<PostApiV1ModelingPathsByPathRunIdClientSummaryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdClientSummaryError, Options<PostApiV1ModelingPathsByPathRunIdClientSummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdClientSummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sets (or clears) the per-step client-facing summary for a single calculator
 * step of the path. Distinct from the advisor-only internal note.
 */
export const postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdClientSummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdInputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdOutputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseMutation = (options?: Partial<Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseData>>): UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseResponse, PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseError, Options<PostApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingPathsByPathRunIdStepsByPathRunStepIdFormResponse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingCustomModulesQueryKey = (options?: Options<GetApiV1ModelingCustomModulesData>) => createQueryKey('getApiV1ModelingCustomModules', options);

export const getApiV1ModelingCustomModulesOptions = (options?: Options<GetApiV1ModelingCustomModulesData>) => queryOptions<GetApiV1ModelingCustomModulesResponse, GetApiV1ModelingCustomModulesError, GetApiV1ModelingCustomModulesResponse, ReturnType<typeof getApiV1ModelingCustomModulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingCustomModules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingCustomModulesQueryKey(options)
});

export const postApiV1ModelingCustomModulesMutation = (options?: Partial<Options<PostApiV1ModelingCustomModulesData>>): UseMutationOptions<PostApiV1ModelingCustomModulesResponse, PostApiV1ModelingCustomModulesError, Options<PostApiV1ModelingCustomModulesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingCustomModulesResponse, PostApiV1ModelingCustomModulesError, Options<PostApiV1ModelingCustomModulesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingCustomModules({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiV1ModelingCustomModulesByCustomModuleIdMutation = (options?: Partial<Options<DeleteApiV1ModelingCustomModulesByCustomModuleIdData>>): UseMutationOptions<DeleteApiV1ModelingCustomModulesByCustomModuleIdResponse, DeleteApiV1ModelingCustomModulesByCustomModuleIdError, Options<DeleteApiV1ModelingCustomModulesByCustomModuleIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ModelingCustomModulesByCustomModuleIdResponse, DeleteApiV1ModelingCustomModulesByCustomModuleIdError, Options<DeleteApiV1ModelingCustomModulesByCustomModuleIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1ModelingCustomModulesByCustomModuleId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingCustomModulesByCustomModuleIdQueryKey = (options: Options<GetApiV1ModelingCustomModulesByCustomModuleIdData>) => createQueryKey('getApiV1ModelingCustomModulesByCustomModuleId', options);

export const getApiV1ModelingCustomModulesByCustomModuleIdOptions = (options: Options<GetApiV1ModelingCustomModulesByCustomModuleIdData>) => queryOptions<GetApiV1ModelingCustomModulesByCustomModuleIdResponse, GetApiV1ModelingCustomModulesByCustomModuleIdError, GetApiV1ModelingCustomModulesByCustomModuleIdResponse, ReturnType<typeof getApiV1ModelingCustomModulesByCustomModuleIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingCustomModulesByCustomModuleId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingCustomModulesByCustomModuleIdQueryKey(options)
});

export const putApiV1ModelingCustomModulesByCustomModuleIdMutation = (options?: Partial<Options<PutApiV1ModelingCustomModulesByCustomModuleIdData>>): UseMutationOptions<PutApiV1ModelingCustomModulesByCustomModuleIdResponse, PutApiV1ModelingCustomModulesByCustomModuleIdError, Options<PutApiV1ModelingCustomModulesByCustomModuleIdData>> => {
    const mutationOptions: UseMutationOptions<PutApiV1ModelingCustomModulesByCustomModuleIdResponse, PutApiV1ModelingCustomModulesByCustomModuleIdError, Options<PutApiV1ModelingCustomModulesByCustomModuleIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiV1ModelingCustomModulesByCustomModuleId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingModulesCatalogQueryKey = (options?: Options<GetApiV1ModelingModulesCatalogData>) => createQueryKey('getApiV1ModelingModulesCatalog', options);

export const getApiV1ModelingModulesCatalogOptions = (options?: Options<GetApiV1ModelingModulesCatalogData>) => queryOptions<GetApiV1ModelingModulesCatalogResponse, GetApiV1ModelingModulesCatalogError, GetApiV1ModelingModulesCatalogResponse, ReturnType<typeof getApiV1ModelingModulesCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingModulesCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingModulesCatalogQueryKey(options)
});

export const getApiV1ModelingModuleRunsQueryKey = (options?: Options<GetApiV1ModelingModuleRunsData>) => createQueryKey('getApiV1ModelingModuleRuns', options);

export const getApiV1ModelingModuleRunsOptions = (options?: Options<GetApiV1ModelingModuleRunsData>) => queryOptions<GetApiV1ModelingModuleRunsResponse, GetApiV1ModelingModuleRunsError, GetApiV1ModelingModuleRunsResponse, ReturnType<typeof getApiV1ModelingModuleRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingModuleRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingModuleRunsQueryKey(options)
});

export const postApiV1ModelingModuleRunsMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsData>>): UseMutationOptions<PostApiV1ModelingModuleRunsResponse, PostApiV1ModelingModuleRunsError, Options<PostApiV1ModelingModuleRunsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsResponse, PostApiV1ModelingModuleRunsError, Options<PostApiV1ModelingModuleRunsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRuns({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingModuleRunsByModuleRunIdQueryKey = (options: Options<GetApiV1ModelingModuleRunsByModuleRunIdData>) => createQueryKey('getApiV1ModelingModuleRunsByModuleRunId', options);

export const getApiV1ModelingModuleRunsByModuleRunIdOptions = (options: Options<GetApiV1ModelingModuleRunsByModuleRunIdData>) => queryOptions<GetApiV1ModelingModuleRunsByModuleRunIdResponse, GetApiV1ModelingModuleRunsByModuleRunIdError, GetApiV1ModelingModuleRunsByModuleRunIdResponse, ReturnType<typeof getApiV1ModelingModuleRunsByModuleRunIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingModuleRunsByModuleRunId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingModuleRunsByModuleRunIdQueryKey(options)
});

/**
 * Disables the public share link for this modelation.
 */
export const deleteApiV1ModelingModuleRunsByModuleRunIdShareMutation = (options?: Partial<Options<DeleteApiV1ModelingModuleRunsByModuleRunIdShareData>>): UseMutationOptions<DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponse, DeleteApiV1ModelingModuleRunsByModuleRunIdShareError, Options<DeleteApiV1ModelingModuleRunsByModuleRunIdShareData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiV1ModelingModuleRunsByModuleRunIdShareResponse, DeleteApiV1ModelingModuleRunsByModuleRunIdShareError, Options<DeleteApiV1ModelingModuleRunsByModuleRunIdShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiV1ModelingModuleRunsByModuleRunIdShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Turns on (or returns the existing) public share link for this modelation.
 * The run must be bound to a client. Returns the opaque token the FE uses to
 * build the public client-view URL.
 */
export const postApiV1ModelingModuleRunsByModuleRunIdShareMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdShareData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdShareResponse, PostApiV1ModelingModuleRunsByModuleRunIdShareError, Options<PostApiV1ModelingModuleRunsByModuleRunIdShareData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdShareResponse, PostApiV1ModelingModuleRunsByModuleRunIdShareError, Options<PostApiV1ModelingModuleRunsByModuleRunIdShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * E-mails the existing public share link of this modelation to its bound client.
 * The run must already be shared and the client must have an e-mail on file.
 * The message is queued for asynchronous delivery (transactional outbox).
 */
export const postApiV1ModelingModuleRunsByModuleRunIdShareEmailMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdShareEmailData>>): UseMutationOptions<unknown, PostApiV1ModelingModuleRunsByModuleRunIdShareEmailError, Options<PostApiV1ModelingModuleRunsByModuleRunIdShareEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, PostApiV1ModelingModuleRunsByModuleRunIdShareEmailError, Options<PostApiV1ModelingModuleRunsByModuleRunIdShareEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdShareEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingModuleRunsPublicByPublicShareTokenQueryKey = (options: Options<GetApiV1ModelingModuleRunsPublicByPublicShareTokenData>) => createQueryKey('getApiV1ModelingModuleRunsPublicByPublicShareToken', options);

/**
 * Public, anonymously-readable client view of a shared modelation, resolved
 * by its opaque share token. No authentication required; returns 404 when the
 * token is unknown or the link has been revoked. No client PII is exposed.
 */
export const getApiV1ModelingModuleRunsPublicByPublicShareTokenOptions = (options: Options<GetApiV1ModelingModuleRunsPublicByPublicShareTokenData>) => queryOptions<GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponse, GetApiV1ModelingModuleRunsPublicByPublicShareTokenError, GetApiV1ModelingModuleRunsPublicByPublicShareTokenResponse, ReturnType<typeof getApiV1ModelingModuleRunsPublicByPublicShareTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingModuleRunsPublicByPublicShareToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingModuleRunsPublicByPublicShareTokenQueryKey(options)
});

export const postApiV1ModelingModuleRunsByModuleRunIdCloseMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdCloseData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdCloseResponse, PostApiV1ModelingModuleRunsByModuleRunIdCloseError, Options<PostApiV1ModelingModuleRunsByModuleRunIdCloseData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdCloseResponse, PostApiV1ModelingModuleRunsByModuleRunIdCloseError, Options<PostApiV1ModelingModuleRunsByModuleRunIdCloseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdClose({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingModuleRunsByModuleRunIdReopenMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdReopenData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdReopenResponse, PostApiV1ModelingModuleRunsByModuleRunIdReopenError, Options<PostApiV1ModelingModuleRunsByModuleRunIdReopenData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdReopenResponse, PostApiV1ModelingModuleRunsByModuleRunIdReopenError, Options<PostApiV1ModelingModuleRunsByModuleRunIdReopenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdReopen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sets (or clears) the client-facing summary ("shrnutí pro klienta") for this
 * standalone modelation. Send an empty/null body value to clear it.
 */
export const postApiV1ModelingModuleRunsByModuleRunIdClientSummaryMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponse, PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryError, Options<PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryResponse, PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryError, Options<PostApiV1ModelingModuleRunsByModuleRunIdClientSummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdClientSummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingModuleRunsByModuleRunIdInputsMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdInputsData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdInputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdInputsError, Options<PostApiV1ModelingModuleRunsByModuleRunIdInputsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdInputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdInputsError, Options<PostApiV1ModelingModuleRunsByModuleRunIdInputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdInputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1ModelingModuleRunsByModuleRunIdOutputsMutation = (options?: Partial<Options<PostApiV1ModelingModuleRunsByModuleRunIdOutputsData>>): UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdOutputsError, Options<PostApiV1ModelingModuleRunsByModuleRunIdOutputsData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingModuleRunsByModuleRunIdOutputsResponse, PostApiV1ModelingModuleRunsByModuleRunIdOutputsError, Options<PostApiV1ModelingModuleRunsByModuleRunIdOutputsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingModuleRunsByModuleRunIdOutputs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1ModelingFormsPaletteQueryKey = (options?: Options<GetApiV1ModelingFormsPaletteData>) => createQueryKey('getApiV1ModelingFormsPalette', options);

export const getApiV1ModelingFormsPaletteOptions = (options?: Options<GetApiV1ModelingFormsPaletteData>) => queryOptions<GetApiV1ModelingFormsPaletteResponse, GetApiV1ModelingFormsPaletteError, GetApiV1ModelingFormsPaletteResponse, ReturnType<typeof getApiV1ModelingFormsPaletteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingFormsPalette({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingFormsPaletteQueryKey(options)
});

export const getApiV1ModelingFormsCountriesQueryKey = (options?: Options<GetApiV1ModelingFormsCountriesData>) => createQueryKey('getApiV1ModelingFormsCountries', options);

export const getApiV1ModelingFormsCountriesOptions = (options?: Options<GetApiV1ModelingFormsCountriesData>) => queryOptions<GetApiV1ModelingFormsCountriesResponse, GetApiV1ModelingFormsCountriesError, GetApiV1ModelingFormsCountriesResponse, ReturnType<typeof getApiV1ModelingFormsCountriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ModelingFormsCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ModelingFormsCountriesQueryKey(options)
});

/**
 * Generates (or improves) a client-facing summary ("shrnutí pro klienta") for a
 * modelace/cesta from the supplied calculator inputs/results and the advisor's
 * draft. The result is shown to the advisor in a dialog to adopt or discard — it
 * is not persisted by this call.
 */
export const postApiV1ModelingAiClientSummaryMutation = (options?: Partial<Options<PostApiV1ModelingAiClientSummaryData>>): UseMutationOptions<PostApiV1ModelingAiClientSummaryResponse, PostApiV1ModelingAiClientSummaryError, Options<PostApiV1ModelingAiClientSummaryData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1ModelingAiClientSummaryResponse, PostApiV1ModelingAiClientSummaryError, Options<PostApiV1ModelingAiClientSummaryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1ModelingAiClientSummary({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1FilesMutation = (options?: Partial<Options<PostApiV1FilesData>>): UseMutationOptions<PostApiV1FilesResponse, PostApiV1FilesError, Options<PostApiV1FilesData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1FilesResponse, PostApiV1FilesError, Options<PostApiV1FilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1Files({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1FilesByPublicTokenContentQueryKey = (options: Options<GetApiV1FilesByPublicTokenContentData>) => createQueryKey('getApiV1FilesByPublicTokenContent', options);

export const getApiV1FilesByPublicTokenContentOptions = (options: Options<GetApiV1FilesByPublicTokenContentData>) => queryOptions<unknown, GetApiV1FilesByPublicTokenContentError, unknown, ReturnType<typeof getApiV1FilesByPublicTokenContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1FilesByPublicTokenContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1FilesByPublicTokenContentQueryKey(options)
});

export const getApiV1ClientsExternalQueryKey = (options?: Options<GetApiV1ClientsExternalData>) => createQueryKey('getApiV1ClientsExternal', options);

export const getApiV1ClientsExternalOptions = (options?: Options<GetApiV1ClientsExternalData>) => queryOptions<GetApiV1ClientsExternalResponse, GetApiV1ClientsExternalError, GetApiV1ClientsExternalResponse, ReturnType<typeof getApiV1ClientsExternalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ClientsExternal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ClientsExternalQueryKey(options)
});

export const getApiV1ClientsExternalByPersonalNumberQueryKey = (options: Options<GetApiV1ClientsExternalByPersonalNumberData>) => createQueryKey('getApiV1ClientsExternalByPersonalNumber', options);

export const getApiV1ClientsExternalByPersonalNumberOptions = (options: Options<GetApiV1ClientsExternalByPersonalNumberData>) => queryOptions<GetApiV1ClientsExternalByPersonalNumberResponse, GetApiV1ClientsExternalByPersonalNumberError, GetApiV1ClientsExternalByPersonalNumberResponse, ReturnType<typeof getApiV1ClientsExternalByPersonalNumberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1ClientsExternalByPersonalNumber({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1ClientsExternalByPersonalNumberQueryKey(options)
});

export const postApiV1AuthSignInMutation = (options?: Partial<Options<PostApiV1AuthSignInData>>): UseMutationOptions<PostApiV1AuthSignInResponse, PostApiV1AuthSignInError, Options<PostApiV1AuthSignInData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthSignInResponse, PostApiV1AuthSignInError, Options<PostApiV1AuthSignInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1AuthSignIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiV1AuthBrokerSignInMutation = (options?: Partial<Options<PostApiV1AuthBrokerSignInData>>): UseMutationOptions<PostApiV1AuthBrokerSignInResponse, PostApiV1AuthBrokerSignInError, Options<PostApiV1AuthBrokerSignInData>> => {
    const mutationOptions: UseMutationOptions<PostApiV1AuthBrokerSignInResponse, PostApiV1AuthBrokerSignInError, Options<PostApiV1AuthBrokerSignInData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiV1AuthBrokerSignIn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiV1AuthUserinfoQueryKey = (options?: Options<GetApiV1AuthUserinfoData>) => createQueryKey('getApiV1AuthUserinfo', options);

export const getApiV1AuthUserinfoOptions = (options?: Options<GetApiV1AuthUserinfoData>) => queryOptions<GetApiV1AuthUserinfoResponse, GetApiV1AuthUserinfoError, GetApiV1AuthUserinfoResponse, ReturnType<typeof getApiV1AuthUserinfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiV1AuthUserinfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiV1AuthUserinfoQueryKey(options)
});
